import { createInertiaApp, router } from "@inertiajs/react"

import MarketingPersistentLayout from "@/layouts/marketing-persistent-layout"
import { trackPageView } from "@/lib/analytics"
import { readExactTitle } from "@/lib/page-title"
import { resolvePage, type PageModule } from "@/lib/resolve-page"
import { visitOptions } from "@/lib/view-transitions"

const appName = import.meta.env.VITE_APP_NAME ?? "Fahrdienst Software"

const marketingPages = import.meta.glob<PageModule>([
  "../pages/Home/Index.tsx",
  "../pages/Preise/Index.tsx",
  "../pages/Blog/Index.tsx",
  "../pages/Blog/Show.tsx",
  "../pages/MarketingFeature/Show.tsx",
  "../pages/MarketingDirectory/Show.tsx",
  "../pages/Alternative/Show.tsx",
  "../pages/Solution/Show.tsx",
  "../pages/Legal/Show.tsx",
  "../pages/ContactPage/Show.tsx",
  "../pages/OrderBookTemplate/Show.tsx",
  "../pages/CustomerStory/Show.tsx",
])

void createInertiaApp({
  title: (title) => {
    const exact = readExactTitle(title)
    if (exact !== null) return exact

    return title ? `${title} - ${appName}` : appName
  },

  resolve: (name) => resolvePage(marketingPages, name),

  layout: () => [MarketingPersistentLayout],

  strictMode: true,

  defaults: {
    form: {
      forceIndicesArrayFormatInFormData: false,
      withAllErrors: true,
    },
    visitOptions,
  },

  progress: {
    color: "#4B5563",
  },
}).catch((error: unknown) => {
  // Ohne Inertia-Wurzel (#app) ist hier nichts zu starten.
  if (document.getElementById("app")) throw error
})

// Die Tracking-Snippets im Rails-Layout melden den servergerenderten Einstieg.
// Erst spätere Inertia-Navigationen werden hier zusätzlich erfasst.
let entryPageReported = false

router.on("navigate", (event) => {
  if (entryPageReported) {
    trackPageView(event.detail.page.url, { signedIn: false })
  } else {
    entryPageReported = true
  }
})
